/*eslint-disable*/
import {mapState} from 'vuex'
import {getPreviousLocation} from './getPreviousLocation'

export default {
    props: {
        showTransition: Boolean,
        city: String,
        zoomEnded: Boolean,
        panEnded: Boolean
    },
    watch: {
        showTransition: {
            handler (newValue, oldValue) {
                if (oldValue !== undefined) {
                    this.$emit('disableActions', true);
                } else if (oldValue === undefined && newValue) {
                    this.$nextTick(() => {
                        let element = document.getElementById(this.country[this.city]);
                        let classString = element.getAttribute('class');
                        element.setAttribute('class', classString.replace(/is-invisible/g, ''));
                    });
                }
            },
            immediate: true
        },
        zoomEnded (val) {
            if (val && this.user.mapLocation.name === this.city) {
                this.getPoints();
            }
        },
        panEnded (val) {
            if (val && this.user.mapLocation.name === this.city && this.currentIndex !== this.elements.length) {
                this.showPoint();
            }
        }
    },
    data () {
        return {
            elements: [],
            currentIndex: 0,
            country: {
                Moscow: 'Russia',
                Oslo: 'Norway',
                Berlin: 'Germany',
                Paris: 'France',
                Madrid: 'Spain',
                Rome: 'Italy',
                Istanbul: 'Turkey',
                Astana: 'Kazakhstan',
                'New-Delhi': 'India',
                Bangkok: 'Thailand',
                Beijing: 'China',
                Tokyo: 'Japan',
                Cairo: 'Egypt',
                Algeria: 'Algeria-wrapper',
                Marrakesh: 'Morocco',
                SaharaDesert: 'Africa_1',
                Bamako: 'Mali',
                Kinshasa: 'Congo_1',
                CongoRiver: 'Congo_2',
                CapeTown: 'SouthAfrica',
                Tanzania: 'Tanzania_1',
                MountKilimanjaro: 'Tanzania_2',
                AddisAbaba: 'Ethiopia',
                MadagascarIsland: 'Madagascar',
                EasterIsland: 'Chile_1',
                AtacamaDesert: 'Chile_2',
                'Buenos-Aires': 'Argentina_1',
                'Punto-Tombo': 'Argentina_2',
                ColoradoLagoon: 'Bolivia',
                'Machu-Picchu': 'Peru',
                Quito: 'Ecuador_1',
                GalapagosIslands: 'Ecuador_2',
                Guatape: 'Colombia',
                AngelFalls: 'Venezuela',
                AmazonRiver: 'Brazil_1',
                RioDeJaneiro: 'Brazil_2',
                Sydney: 'Australia_1',
                BlueMountains: 'BlueMountains-wrapper',
                RainForest: 'Tasmania',
                KangarooIsland: 'KangarooIsland-wrapper',
                CliffUluru: 'CliffUluru-wrapper',
                LakeHiller: 'LakeHiller-wrapper',
                PinnacleDesert: 'PinnacleDesert-wrapper',
                CockatooNationalPark: 'CockatooNationalPark-wrapper',
                PapuaNewGuinea: 'PapuaNewGuinea-wrapper',
                GreatBarrierReef: 'GreatBarrierReef-wrapper',
                Hobbiton: 'Hobbiton-wrapper',
                Wellington: 'NewZealand',
                ChurchOfTheHolyTrinity: 'ChurchOfTheHolyTrinity-wrapper',
                MountElsworth: 'MountElsworth-wrapper',
                Iceberg: 'Iceberg-wrapper',
                IceMarathon: 'IceMarathon-wrapper',
                AntarcticStationAmundsenScott: 'AntarcticStationAmundsenScott-wrapper',
                Icebreaker: 'Icebreaker-wrapper',
                AnimalsOfAntarctica: 'AnimalsOfAntarctica-wrapper',
                ResearchStationProgress: 'ResearchStationProgress-wrapper',
                JurassicPark: 'Cuba',
                Kingston: 'Jamaica',
                SanJose: 'CostaRica',
                Palenque: 'Mexico_1',
                MexicoCity: 'Mexico_2',
                Disneyland: 'USA_1',
                NewYork: 'USA_2',
                Ottawa: 'Canada_1',
                Calgary: 'Canada_2',
                StanleyPark: 'Canada_3',
                Alaska: 'USA_3',
                Greenland: 'Denmark',
                ISS: 'Space_1',
                Moon: 'Space_2',
                Sun: 'Space_3',
                Mercury: 'Space_4',
                Jupiter: 'Space_5',
                Mars: 'Space_6',
                Neptune: 'Space_7',
                Asteroids: 'Space_8',
                Uranus: 'Space_9',
                Saturn: 'Space_10',
                BlackHole: 'Space_11',
                Venus: 'Space_12'
            },
            cases: this.$i18n.t('mapModal.cases')
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user
        })
    },
    methods: {
        getPoints () {
            let component = document.getElementById(this.country[this.city]);
            let classString = component.getAttribute('class');
            component.setAttribute('class', classString.replace(/is-invisible/g, ''));
            this.elements = component.children;
            this.elements = Array.from(this.elements);
            this.elements.sort((first, second) => {
                let firstId = first.getAttribute('id');
                let secondId = second.getAttribute('id');
                if (!firstId.includes('point')) {
                    return 1;
                }
                if (!secondId.includes('point')) {
                    return -1;
                }
                return +firstId.match(/[0-9]+/)[0] - (+secondId.match(/[0-9]+/)[0]);
            });
            for (let i = 0; i < this.elements.length; i++) {
                let elem = this.elements[i];
                let classString = elem.getAttribute('class');
                elem.setAttribute('class', classString + ' point');
            }
            this.showPoint();
        },
        showPoint () {
            let element = this.elements[this.currentIndex];
            let previousElement;
            !this.currentIndex
                ? previousElement = document.getElementById(getPreviousLocation(this.city))
                : previousElement = this.elements[this.currentIndex - 1];
            this.$emit('transition', element, previousElement);
            let classString = element.getAttribute('class');
            element.setAttribute('class', classString + ' show-point');
            this.currentIndex++;
            if (this.currentIndex === this.elements.length) {
                this.$toasted.success(
                    this.$i18n.t('map.map_progress_nextCity', {
                        text: this.cases.prepositional[this.user.mapLocation.name]
                    })
                );
                setTimeout(() => {
                    this.$emit('disableActions', false);
                    this.$emit('openModal');
                }, 800);
            }
        }
    }
}